import React, { Component } from 'react'
import List from './List'
import Store from './store'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'
import { COUPONS_PATH_A } from '@constant'

export default class extends Component {
  constructor(p) {
    super(p)
    const { id } = this.props.routeParams

    this.store = new Store()
    this.store.id = id
  }
  render() {
    const { title } = this.props.location.query

    return (
      <HeaderView>
        <p className={styles.title}>
          <a href={COUPONS_PATH_A}>优惠券 ： </a>
          <span>{title}</span>
        </p>

        <List store={this.store} />
      </HeaderView>
    )
  }
}
